"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var Layout_1 = __importDefault(require("../Layout"));

var md_1 = require("react-icons/md");

var classnames_1 = require("./classnames");

var ChatIcon_1 = __importDefault(require("../ChatIcon"));

function Document(props) {
  var title = props.title,
      subtitle = props.subtitle,
      isChatIconVisible = props.isChatIconVisible,
      icon = props.icon,
      onClick = props.onClick,
      isUser = props.isUser;
  return React.createElement(Layout_1.default, {
    isUser: isUser
  }, isChatIconVisible && React.createElement(ChatIcon_1.default, {
    isUser: isUser,
    icon: icon
  }), React.createElement("div", {
    className: classnames_1.container,
    onClick: onClick
  }, React.createElement("div", {
    className: classnames_1.innerContent
  }, React.createElement(md_1.MdPictureAsPdf, {
    size: "100px",
    color: "#d7d7d7"
  }), React.createElement("div", {
    className: classnames_1.titleStyle
  }, title), React.createElement("div", {
    className: classnames_1.subTitleStyle
  }, subtitle))));
}

exports.default = Document;